import useVocabulary from './useVocabulary';
import { Vocabulary } from '../../types/catalog';

const selectBrands = (vocabulary: Vocabulary) => vocabulary.brands;

function useBrands(enabled = true) {
  return useVocabulary(enabled, selectBrands);
}

export default useBrands;
